import React from 'react';
import { Button } from '../../buttons';

import * as styles from './index.module.scss';

const BlogCategoryItem = ({
  title,
  slug,
  baseUrlOverwrite = '/blog',
  active
}) => {
  return (
    <li className={(active ? styles.blogCategoryActive : '')}>
      <Button
        colorData={`white`}
        typeData={`default`}
        href={slug ? `${baseUrlOverwrite}/` + slug : baseUrlOverwrite}
        content={title}
        alt={title}
      />
    </li>
  );
}

export default BlogCategoryItem;